import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import { StylesProvider, useModeTokens } from '@rexlabs/styling';
import Tag from '../core';
import { getCompactTokens } from '../modes/compact';
var baseTokens = {
  tag: {
    background: {
      color: function color(_ref) {
        var token = _ref.token;
        return token('palette.yellow.200', 'red');
      }
    },
    color: function color(_ref2) {
      var token = _ref2.token;
      return token('palette.yellow.900', 'black');
    }
  }
};
var modeTokens = [{
  mode: 'compact',
  tokens: getCompactTokens('tag.priority.warm.compact')
}];

function PriorityWarmTag(_ref3, ref) {
  var _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? 'Warm' : _ref3$children,
      props = _objectWithoutProperties(_ref3, _excluded);

  var tokens = useModeTokens(baseTokens, modeTokens);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, props, {
    ref: ref
  }), children));
} // eslint-disable-next-line react/display-name


export default /*#__PURE__*/forwardRef(PriorityWarmTag);